/** Match backend apps.societies.seo — keep markers and thresholds in sync. */
export const SOCIETY_INDEXABLE_MIN_DESCRIPTION_LEN = 2000;

export const SOCIETY_TEMPLATE_MARKERS = [
  'Complete Area Guide, Property Market, Lifestyle & Investment Potential',
  'What Residents Appreciate',
  'Property Market Overview',
  'Challenges and Considerations',
  'Company Profile, Projects & Real Estate Overview',
  'Investment Perspective',
  'Limitations and Market Challenges',
];

export const SOCIETY_TEMPLATE_MARKER_MIN_HITS = 2;

/** Strong content → full indexable /societies/:slug page; otherwise treat as weak. */
export function isSocietyPageIndexable(description) {
  const text = String(description || '').trim();
  if (text.length < SOCIETY_INDEXABLE_MIN_DESCRIPTION_LEN) {
    return false;
  }
  const hits = SOCIETY_TEMPLATE_MARKERS.reduce(
    (count, marker) => count + (text.includes(marker) ? 1 : 0),
    0,
  );
  return hits < SOCIETY_TEMPLATE_MARKER_MIN_HITS;
}

export function shouldOpenSocietyAsFullPage(society) {
  return isSocietyPageIndexable(society?.description);
}
